/**
 * Reads an error message from a Portal API failure, preferring RFC7807 ProblemDetails
 * fields. Mirrors the precedence already used in ProjectFiles and the Auth0 Actions
 * (detail -> title -> error -> message), with fallbacks for legacy { error } and
 * plain-string bodies so partially-migrated endpoints keep working.
 *
 * @param {*} error RTK Query error (or similar) with an optional `data` payload.
 * @param {string} fallback Message to use when nothing usable is found.
 * @returns {string}
 */
export const getProblemDetailMessage = (error, fallback = 'Something went wrong. Please try again.') => {
	const data = error?.data;

	if (typeof data === 'string' && data.trim()) {
		return data.trim();
	}

	if (data && typeof data === 'object') {
		const message = data.detail || data.title || data.error || data.message;
		if (message) return message;
	}

	return error?.message || fallback;
};
